import { lighten } from '@mui/material/styles';
import React, { useEffect, useState } from 'react';
import { makeStyles, useTheme } from '../../../styles';
import { getTimeLeft } from './remainingTimeFormatter';
const defaultTime = 60;
const stroke = 120;
const strokeWidth = 3;
const expanse = 52;
const padding = 2;
export function CircleTimer(props) {
    const { className, id, onStopped, onTick, seconds } = props;
    const [time, setTime] = useState(seconds || defaultTime);
    const [stopped, setStopped] = useState(false);
    const theme = useTheme();
    const useStyles = makeStyles({
        circleTimerSvg: {
            backgroundColor: 'transparent',
            transform: 'rotateZ(-90deg)',
        },
        circle: {
            stroke: !stopped ? theme.colors.warning.main : theme.colors.success.main,
            strokeWidth,
            fill: 'transparent',
            strokeDashoffset: stroke,
            strokeDasharray: 0,
            animation: `${props.seconds || defaultTime}s circletimer linear`,
            zIndex: 1000,
        },
        circleShadow: {
            stroke: lighten(theme.colors.warning.main, 0.9),
            strokeWidth,
            fill: 'transparent',
            strokeDashoffset: stroke,
            strokeDasharray: 0,
        },
        circleBackground: {
            fill: 'white',
        },
        timer: {
            position: 'absolute',
            width: expanse,
            height: expanse,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: theme.colors.text[900],
            fontSize: 10,
            fontWeight: 700,
            zIndex: 10,
        },
        '@global': {
            '@keyframes circletimer': {
                '0%': {
                    strokeDashoffset: 0,
                    strokeDasharray: stroke,
                },
                '100%': {
                    strokeDashoffset: stroke,
                    strokeDasharray: stroke,
                },
            },
        },
    });
    const classes = useStyles();
    useEffect(() => {
        const countDown = setInterval(() => {
            setTime((currentTime) => {
                if (onTick) {
                    onTick(currentTime - 1);
                }
                if (currentTime <= 1) {
                    clearInterval(countDown);
                    setStopped(true);
                    if (onStopped) {
                        onStopped();
                    }
                    return 0;
                }
                return currentTime - 1;
            });
        }, 1000);
        return () => clearInterval(countDown);
    }, [onStopped, onTick]);
    return (React.createElement("div", { className: className, id: id, style: { width: expanse, height: expanse } },
        React.createElement("div", { className: classes.timer },
            React.createElement("div", null, getTimeLeft(time))),
        React.createElement("svg", { className: classes.circleTimerSvg, width: expanse, height: expanse },
            React.createElement("circle", { className: classes.circleBackground, cx: expanse / 2, cy: expanse / 2, r: expanse / Math.PI + (padding * Math.PI + 1) }),
            React.createElement("circle", { className: classes.circleShadow, cx: expanse / 2, cy: expanse / 2, r: expanse / Math.PI + padding }),
            React.createElement("circle", { className: classes.circle, cx: expanse / 2, cy: expanse / 2, r: expanse / Math.PI + padding }))));
}
//# sourceMappingURL=CircleTimer.js.map